import { ProductGroup } from "../@types";

export const PRODUCT_GROUPS_MODAL_STATE =
  "[ PRODUCT_GROUPS ] Product Groups Modal State";

export interface IProductGroupsModalState {
  type: typeof PRODUCT_GROUPS_MODAL_STATE;
  payload: boolean;
}

export const GET_PRODUCT_GROUP_FOR_UPDATE =
  "[ PRODUCT_GROUPS ] Get Product Group For Update";

export interface IGetProductGroupForUpdate {
  type: typeof GET_PRODUCT_GROUP_FOR_UPDATE;
  payload: ProductGroup | undefined;
}

export const IS_PRODUCT_GROUP_FOR_UPDATE =
  "[ PRODUCT_GROUPS ] Is Product Group For Update";

export interface IIsProductGroupForUpdate {
  type: typeof IS_PRODUCT_GROUP_FOR_UPDATE;
  payload: boolean;
}

export const SWITCH_PRODUCT_GROUPS_REFRESH_TABLE =
  "[ PRODUCT_GROUPS ] Switch Product Groups Refresh Table";

export interface ISwitchProductGroupsRefreshTable {
  type: typeof SWITCH_PRODUCT_GROUPS_REFRESH_TABLE;
  payload: boolean;
}
